import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getAllAssignee = createAsyncThunk(
  "Assignee/get",
  async (payload, { rejectWithValue, dispatch }) => {
    // dispatch(resetAssigneeList());
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.USER.GET_ASSIGNEE_USER}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.USER.GET_ASSIGNEE_USER}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllRecruiter = createAsyncThunk(
  "Recruiter/get",
  async (payload, { rejectWithValue }) => {
    // try {
    //   const { data } = await axios.get(`${API_URL.USER.GET_RECRUITER_USER}`);
    //   return data;
    // }
    try {
      if (payload) {
        const filteredPayload = Object.fromEntries(
          Object.entries(payload).filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
        );
        const params = new URLSearchParams();

        for (const [key, value] of Object.entries(filteredPayload)) {
          if (Array.isArray(value)) {
            // If the value is an array, append each item with the same key
            value.forEach((item) => {
              params.append(key, item);
            });
          } else {
            // For non-array values, just append normally
            params.append(key, value);
          }
        }
        const queryString = params.toString();

        const apiUrl = `${API_URL.USER.GET_RECRUITER_USER}?${queryString}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data, isSearch: !!payload.searchText };
      } else {
        const apiUrl = `${API_URL.USER.GET_RECRUITER_USER}`;
        const { data } = await axios.get(apiUrl);

        return { data: data.data };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllRoles = createAsyncThunk(
  "Role/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.ROLE.GET_ROLE}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllNCStatus = createAsyncThunk(
  "NCStatus/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.CANDIDATE.GET_NC_STATUS}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllCandidate = createAsyncThunk(
  "Candidate/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.CANDIDATE.GET_CANDIDATE_TYPE}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllDivision = createAsyncThunk(
  "Division/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.VERIFICATION.GET_DIVISIONS}/GetAllDivisions`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllTeams = createAsyncThunk(
  "Team/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.VERIFICATION.GET_TEAMS}/GetAllTeams`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllApplicationStatus = createAsyncThunk(
  "NCApplicationStatus/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.CANDIDATE.GET_APPLICATION_STATUS}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// API CALL FOR UNAUTHORIZED ACCESS

export const unauthorizedAccessPing = createAsyncThunk(
  "unauthorizedAccessPing/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.VERIFICATION.PING}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const lovSlice = createSlice({
  name: "lov",
  initialState: {
    dropdown_assignee_list: [],
    dropdown_recruiter_list: [],
    dropdown_role_list: [],
    dropdown_nc_status_list: [],
    dropdown_candidate_list: [],
    dropdown_application_status_list: [],
    division_list: [],
    teams_list: [],
  },
  reducers: {
    resetAssigneeList(state) {
      state.dropdown_assignee_list = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAssignee.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_assignee_list = data.list;
      } else {
        const combinedList = [...state.dropdown_assignee_list, ...data.list];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values()
        );

        state.dropdown_assignee_list = uniqueList;
      }
    });
    builder.addCase(getAllRecruiter.fulfilled, (state, action) => {
      const { data, isSearch } = action.payload;
      if (isSearch) {
        state.dropdown_recruiter_list = data.list;
      } else {
        const combinedList = [...state.dropdown_recruiter_list, ...data.list];

        // Use Map to ensure unique records by `id`
        const uniqueList = Array.from(
          new Map(combinedList.map((item) => [item.id, item])).values()
        );

        state.dropdown_recruiter_list = uniqueList;
      }
    });
    builder.addCase(getAllRoles.fulfilled, (state, action) => {
      state.dropdown_role_list = action.payload.data.list;
    });
    builder.addCase(getAllNCStatus.fulfilled, (state, action) => {
      state.dropdown_nc_status_list = action.payload.data.list;
    });
    builder.addCase(getAllCandidate.fulfilled, (state, action) => {
      state.dropdown_candidate_list = action.payload.data.list;
    });
    builder.addCase(getAllDivision.fulfilled, (state, action) => {
      state.division_list = action.payload.data.list;
    });
    builder.addCase(getAllTeams.fulfilled, (state, action) => {
      state.teams_list = action.payload.data.list;
    });
    builder.addCase(getAllApplicationStatus.fulfilled, (state, action) => {
      state.dropdown_application_status_list = action.payload.data.list;
    });
  },
});

export const { resetAssigneeList } = lovSlice.actions;
export default lovSlice.reducer;
